module.exports = __webpack_public_path__ + "static/media/brahmand.aaa916a2.mp4";